import './App.css';
import {Route, Switch} from 'react-router-dom';

import SignIn from './components/SignIn';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import CoreContainer from './components/CoreContainer';
import CustomSnackbar from './features/snackbar/CustomSnackbar';

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/signin" component={SignIn} exact />
        <Route path="/forgotpassword" component={ForgotPassword} exact />
        <Route path="/resetpassword" component={ResetPassword} exact />
        <Route path="/" component={CoreContainer} />
      </Switch>
      <CustomSnackbar />
    </div>
  );
}

export default App;
